function columns(translator) {
  return [
    {
      key: 'displayValue',
      name: translator(
        'pages.adminInvitationGroups.invitationGroupAdminPanelAndList.invitationKeyDisplayColumn',
      ),
      ariaLabel: translator(
        'pages.adminInvitationGroups.invitationGroupAdminPanelAndList.invitationKeyDisplayColumn',
      ),
      fieldName: 'displayValue',
      data: 'string',
      isPadded: true,
      isResizable: true,
      minWidth: 450,
      maxWidth: 450,
    },
    {
      key: 'type',
      name: translator(
        'pages.adminInvitationGroups.invitationGroupAdminPanelAndList.invitationKeyTypeColumn',
      ),
      ariaLabel: translator(
        'pages.adminInvitationGroups.invitationGroupAdminPanelAndList.invitationKeyTypeColumn',
      ),
      fieldName: 'type',
      data: 'string',
      isPadded: true,
      isResizable: true,
      minWidth: 100,
      maxWidth: 150,
    },
  ];
}

export { columns };
